import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'

function initialState() {
    return {
        all: [],
        query: '',
        filter: '',
        loading: false,
        permission: {}
    }
}

const getters = {
    all: state => state.all,
    loading: state => state.loading,
    serverPagination: state => state.serverPagination,
    filter: state => state.filter,
    query: state => state.query,
    permission: state => state.permission,
    totalNumber: state => state.totalNumber
}

const actions = {
    fetchData({commit}) {
        commit('setLoading', true);
        Http.get(API_URL + VERSION + '/permissions?all')
            .then(response => {
                commit('setAll', response.data.data)
            })
            .finally(() => {
                commit('setLoading', false)
            })
    }
}

const mutations = {
    setAll(state, items) {
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setPermission(state, permission) {
        state.permission = permission
    },
    setServerPagination(state, item) {
        state.serverPagination = item
    },
    setTotalNumber(state, item) {
        state.totalNumber = item
    },
    setRowsPerPage(state, item) {
        state.serverpagination.itemsPerPage = item;
    },
    setQuery(state, query) {
        state.query = query
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setFilter(state, item) {
        state.filter = item
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
